import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginView from '../views/LoginView'
import AdminView from '../views/AdminView'
import User4View from '../views/User4View'
import User3View from '../views/User3View'
import User2View from '../views/User2View'
import User1View from '../views/User1View'
import ConfirmTask from '../views/ConfirmTask.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: LoginView
  },
  {
    path: '/admin',
    name: 'admin',
    component: AdminView
  },
  {
    path: '/user_4',
    name: 'user_4',
    component: User4View
  },
  {
    path: '/user_3',
    name: 'user_3',
    component: User3View
  },
  {
    path: '/user_2',
    name: 'user_2',
    component: User2View
  },
  {
    path: '/user_1',
    name: 'user_1',
    component: User1View
  },
  {
    path: '/confirm_task-task',
    name: 'confirm-task',
    component: ConfirmTask
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
